var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"18vh 0"}},[_c('div',[_c('b-navbar',{attrs:{"type":"dark","variant":"info","fixed":"top"}},[_c('b-navbar-brand',{attrs:{"href":"./#/filmTranslation"}},[_vm._v("电影翻译库")])],1)],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center"}},[_c('a',{staticStyle:{"font-size":"2em","font-weight":"bold"}},[_vm._v("（致谢名单）")])])
}]

export { render, staticRenderFns }